const t = ({ allowSiteImprovementCookies: e, allowAdvertisingCookies: r }) => r ? "2:" : e ? "1:" : "0:";
export {
  t as default
};
